import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import logoHostVSL from '@/assets/logo-hostvsl-white.png';

interface TemplateLightHeaderProps {
  playlistName: string;
  publicTitle?: string;
  favicon?: string;
}

export function TemplateLightHeader({ playlistName, publicTitle, favicon }: TemplateLightHeaderProps) {
  useLanguage();
  return (
    <header 
      className="h-[64px] flex items-center px-8"
      style={{ 
        backgroundColor: '#0A4DFF'
      }}
    >
      <div className="flex items-center gap-3 max-w-[1920px] mx-auto w-full">
        {/* Logo */}
        <img 
          src={favicon || logoHostVSL} 
          alt={translateInterfaceText("Logo")}
          className="h-6 flex-shrink-0 object-contain"
        />
      </div>
    </header>
  );
}
